<div class="ui inverted container section">
  <h1>Create a new Lobby</h1>

  <div class="ui divider"></div>

  <app-lobby-form [onSubmit]="createGame" [creating]="creating" [error]="error"></app-lobby-form>
</div>
